<template>
  <div>
    <div class="modal-user">
      <div
        style="text-align: right"
        class="modal-close"
        @click="closeModal">&#10006;</div>
      <slot name="title">
        <h3 class="modal-title text-center mb-3">Edit</h3>
      </slot>
      <slot name="body">
        <div class="modal-content border-0">
          <form
            @submit.prevent="update"
            @keydown="form.onKeydown($event)">

            <!-- Name -->
            <div class="form-group mb-3 row">
              <label class="col-md-4 col-form-label text-md-start">Name</label>
              <div class="col-md-8">
                <input
                  v-model="form.name"
                  :class="{ 'is-invalid': form.errors.has('name') }"
                  class="form-control"
                  type="text"
                  name="name">
                <has-error
                  :form="form"
                  field="name"/>
              </div>
            </div>

            <!-- Email -->
            <div class="form-group mb-3 row">
              <label class="col-md-4 col-form-label text-md-start">Email</label>
              <div class="col-md-8">
                <input
                  v-model="form.email"
                  :class="{ 'is-invalid': form.errors.has('email') }"
                  class="form-control"
                  type="email"
                  name="email">
                <has-error
                  :form="form"
                  field="email"/>
              </div>
            </div>

            <!-- Role -->
            <div class="form-group mb-3 row">
              <label class="col-md-4 col-form-label text-md-start">Role</label>
              <div class="col-md-8">
                <select
                  v-model="form.role"
                  :class="{ 'is-invalid': form.errors.has('name') }"
                  class="form-control"
                  type="text"
                  name="role"
                >
                  <option
                    v-for="(role, index) in getRolesList"
                    :key="index"
                    :value="role.id">{{ role.name }}</option>
                </select>
                <has-error
                  :form="form"
                  field="role"/>
              </div>
            </div>

            <!-- First Name -->
            <div class="form-group mb-3 row">
              <label class="col-md-4 col-form-label text-md-start">First Name</label>
              <div class="col-md-8">
                <input
                  v-model="form.first_name"
                  :class="{ 'is-invalid': form.errors.has('name') }"
                  class="form-control"
                  type="text"
                  name="first_name">
                <has-error
                  :form="form"
                  field="name"/>
              </div>
            </div>

            <!-- Last Name -->
            <div class="form-group mb-3 row">
              <label class="col-md-4 col-form-label text-md-start">Last Name</label>
              <div class="col-md-8">
                <input
                  v-model="form.last_name"
                  :class="{ 'is-invalid': form.errors.has('name') }"
                  class="form-control"
                  type="text"
                  name="last_name">
                <has-error
                  :form="form"
                  field="name"/>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="modal-footer border-0">
              <div class="col-md-4 col-sm-4 ml-md-auto text-md-end">
                <v-button
                  :loading="form.busy"
                  type="success">
                  Update
                </v-button>
              </div>
            </div>
          </form>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import Form from "vform";
import {mapActions, mapGetters} from "vuex";
import Swal from "sweetalert2";
import profileMixin from "../../../mixins/profileMixin";

export default {
  mixins: [profileMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    form: new Form({
      id: '',
      name: '',
      email: '',
      role: '',
      first_name: '',
      last_name: '',
    }),
    show: false
  }),

  computed: {
    ...mapGetters(['editUserId', 'adminData', 'roles', 'user']),

    getUserData() {
      return this.adminData.find((user) => {
        return user.id === this.editUserId
      })
    },

    getRolesList() {
      return this.roles.map((role) => {
        return {
          id: role.id,
          name: role.name
        }
      })
    },

    selectedRole() {
      return this.getUserData.roles.find((role) => {
        return role.id
      })
    }
  },

  watch: {
    getUserData: function (user) {
      this.form.keys().forEach(key => {
        this.form[key] = user[key] || user.profile[key]
      })
      this.form.role = this.selectedRole.id
    }
  },

  methods: {
    ...mapActions(['adminEditUser']),
    closeModal: function () {
      this.showModal(false)
    },
    update() {
      this.adminEditUser(this.form).then(() => {
        Swal.fire(
            'Successfully!',
            'User has been updated successfully.',
            'success'
        ).then(() => {
          this.closeModal()
        })
      }).catch((error) => {
        console.log('error', error);
      });
    },
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/modals/AdminModals/EditUserModal.vue